__turbopack_context__.v({
  "body_rich_text": "Pricing-module-scss-module__dQK6DW__body_rich_text",
  "direction__column": "Pricing-module-scss-module__dQK6DW__direction__column",
  "direction__row": "Pricing-module-scss-module__dQK6DW__direction__row",
  "gradient-glow-blue": "Pricing-module-scss-module__dQK6DW__gradient-glow-blue",
  "gradient-glow-neon": "Pricing-module-scss-module__dQK6DW__gradient-glow-neon",
  "gradient-glow-orange": "Pricing-module-scss-module__dQK6DW__gradient-glow-orange",
  "gradient-glow-pink": "Pricing-module-scss-module__dQK6DW__gradient-glow-pink",
  "gradient-glow-snap-pea": "Pricing-module-scss-module__dQK6DW__gradient-glow-snap-pea",
  "gradient-neon-pink": "Pricing-module-scss-module__dQK6DW__gradient-neon-pink",
  "gradient-pink-blue": "Pricing-module-scss-module__dQK6DW__gradient-pink-blue",
  "gradient-pink-orange": "Pricing-module-scss-module__dQK6DW__gradient-pink-orange",
  "layout__content-leading": "Pricing-module-scss-module__dQK6DW__layout__content-leading",
  "layout__content-trailing": "Pricing-module-scss-module__dQK6DW__layout__content-trailing",
  "module-base": "Pricing-module-scss-module__dQK6DW__module-base",
  "module-content-swap": "Pricing-module-scss-module__dQK6DW__module-content-swap",
  "module_block__contained": "Pricing-module-scss-module__dQK6DW__module_block__contained",
  "module_block__uncontained": "Pricing-module-scss-module__dQK6DW__module_block__uncontained",
  "module_breadcrumbs": "Pricing-module-scss-module__dQK6DW__module_breadcrumbs",
  "section_bg_fill__base": "Pricing-module-scss-module__dQK6DW__section_bg_fill__base",
  "section_bg_fill__gradient": "Pricing-module-scss-module__dQK6DW__section_bg_fill__gradient",
  "section_bg_fill__no-fill": "Pricing-module-scss-module__dQK6DW__section_bg_fill__no-fill",
  "section_bg_fill__raised": "Pricing-module-scss-module__dQK6DW__section_bg_fill__raised",
  "section_container": "Pricing-module-scss-module__dQK6DW__section_container",
  "with_breadcrumb": "Pricing-module-scss-module__dQK6DW__with_breadcrumb",
  "with_navbar": "Pricing-module-scss-module__dQK6DW__with_navbar",
});
